import BannerType from "../../../global/banner-type";
import CaseStudy from "./components/CaseStudy";
import ChannelBanner from "./components/ChannelBanner";
import CommentBanner from "./components/CommentBanner";
import PlatformBanner from "./components/PlatformBanner";
import ServiceBanner from "./components/ServiceBanner";
import SimpleBanner from "./components/SimpleBanner";
import SingleImageBanner from "./components/SingleImageBanner";
import VideoBanner from "./components/VideoBanner";
import classes from "./Banner.module.scss";

/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

const Banner = ({ type = BannerType.CHANNEL_BANNER, ...props }) => {
  switch (type) {
    case BannerType.CHANNEL_BANNER:
      return <ChannelBanner {...props} />;
    case BannerType.SERVICE_BANNER:
      return <ServiceBanner {...props} />;
    case BannerType.CASE_STUDY:
      return <CaseStudy {...props} />;
    case BannerType.COMMENT_BANNER:
      return <CommentBanner {...props} />;
    case BannerType.PLATFORMS_BANNER:
      return <PlatformBanner {...props} />;
    case BannerType.SINGLE_IMAGE_BANNER:
      return <SingleImageBanner {...props} />;
    case BannerType.SIMPLE_BANNER:
      return <SimpleBanner {...props} />;
    case BannerType.VIDEO_BANNER:
      return <VideoBanner {...props} />;
    default:
      return;
  }
};
export default Banner;
